import { render, staticRenderFns } from "./NewRmaProduct.vue?vue&type=template&id=86d4aa90&"
import script from "./NewRmaProduct.vue?vue&type=script&lang=js&"
export * from "./NewRmaProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports